const ApiConfigs = {
  baseUrls: {
    getInfo: 'api/UserInfo',
    getEasar: 'api/easar',
    getMazadat: 'api/mazadat',
    getMoneyReservation: 'api/money-reservation',
  },
};

export {
  ApiConfigs,
};
